'use client';

import React from 'react';

const DisciplineIntroduction = () => {
  return (
    <section id="discipline" className="py-24 lg:py-32 bg-[#0A2540] text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Category declaration */}
          <div className="mb-16 text-center">
            <div className="inline-block px-6 py-2 border-2 border-white/30 mb-8">
              <span className="text-sm font-semibold font-body uppercase tracking-wider">New Discipline</span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-headline mb-8 leading-tight">
              AI Change Leadership
            </h2>
          </div>

          {/* Definition */}
          <div className="mb-16">
            <div className="p-10 border-2 border-white/20 bg-white/5">
              <p className="text-2xl md:text-3xl font-body leading-relaxed text-white/95">
                The discipline of leading continuous, organisation-wide transformation at the speed and scale that AI demands.
              </p>
            </div>
          </div>

          {/* Distinctions */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold font-headline mb-4">Distinct from Change Management</h3>
              <p className="text-lg font-body leading-relaxed text-white/90">
                Traditional change management addresses discrete projects with defined endpoints. AI Change Leadership addresses continuous transformation with no endpoint - change that evolves as rapidly as the technology itself.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold font-headline mb-4">Distinct from AI Strategy</h3>
              <p className="text-lg font-body leading-relaxed text-white/90">
                AI strategy defines what to build and deploy. AI Change Leadership ensures organisations are ready, willing, and able to adopt what has been built - at scale, continuously, across every function.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold font-headline mb-4">Distinct from Digital Transformation</h3>
              <p className="text-lg font-body leading-relaxed text-white/90">
                Digital transformation focuses on technology modernisation. AI Change Leadership focuses on the human systems, behaviours, and leadership capabilities required to operate in an AI-augmented environment.
              </p>
            </div>
          </div>

          {/* Emphasis */}
          <div className="mt-16 text-center">
            <p className="text-xl md:text-2xl font-body leading-relaxed text-white/95">
              This is a <span className="font-bold">category-defining moment</span>. AI Change Leadership is not an evolution of existing disciplines - it is a new discipline for a new era.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DisciplineIntroduction;